var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NavList',{attrs:{"nav-items":_vm.navItems}})
}
var staticRenderFns = []

export { render, staticRenderFns }